/* eslint-disable */
import React, { useState } from "react";

import {
  Flex,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Tooltip,
} from "@chakra-ui/react";
import { CheckIcon, CloseIcon, QuestionIcon } from "@chakra-ui/icons";
import { useTranslation, withTranslation, Trans } from "react-i18next";

export interface B4FNumberProps {
  id: string;
  label: string;
  placeholder?: string;
  value: string;
  onChange: any;
  onBlur?: any;
  isRequired?: boolean;
  isDisabled?: boolean;
  isInvalid?: boolean;
  tooltip?: string;
  visible: boolean;
  spacing?: boolean;
  percentage?: any;
}

export const B4FNumber: React.FC<B4FNumberProps> = (props) => {
  const [value, setValue] = useState(props.value);
  const [touched, setTouched] = useState(false);
  const [highlight, setHighlight] = useState(false);
  const { t, i18n } = useTranslation();

  React.useEffect(() => {
    setValue(props.value);

    if (props.isRequired) {
      if (!isValid(value)) {
        setHighlight(true);
      } else {
        setHighlight(false);
      }
    } else {
      setHighlight(false);
    }
  }, [props.value]);

  function isValid(value: string): boolean {
    const re = /^(\d*\.)?\d+$/;
    if (re.test(value) && props.isRequired) return true;
    else return false;
  }

  const handlePercentage = (event: any) => {
    if (isNaN(event)) {
      return;
    }
    props.onChange(event);
    setValue(event);
  };

  function handleChange(e: { target: { value: string } }) {
    setTouched(true);

    props.onChange({
      id: props.id,
      type: "number",
      value: e.target.value,
      valid: isValid(value),
    });
    const re = /^(\d*\.)?\d+$/;
    if (re.test(e.target.value) || e.target.value === "") {
      setValue(e.target.value);
    }
  }

  function handleBlur(e: { target: { value: any } }) {
    if (props.onBlur) {
      props.onBlur({
        id: props.id,
        type: "number",
        value: e.target.value,
        valid: isValid(value),
        required: props.isRequired,
      });
    }

    if (props.isRequired) {
      if (!isValid(value)) {
        setHighlight(true);
      } else {
        setHighlight(false);
      }
    } else {
      setHighlight(false);
    }
  }

  let rightElement;

  if (isValid(value)) {
    rightElement = (
      <InputRightElement>{<CheckIcon color="green.500" />}</InputRightElement>
    );
  } else if (props.isRequired && touched) {
    rightElement = (
      <InputRightElement>{<CheckIcon color="green.500" />}</InputRightElement>
    );
  }

  if (props.visible) {
    return (
      <FormControl
        key={props.label}
        mb={2}
        isRequired={props.isRequired}
        isDisabled={props.isDisabled}
        isInvalid={props.isInvalid}
        pl={props.spacing ? "6%" : undefined}
      >
        <Flex>
          <FormLabel fontSize={"md"}>{t(props.label)}</FormLabel>
          {props.tooltip && props.tooltip !== "" ? (
            <Tooltip
              label={props.tooltip}
              fontSize="md"
              bg="brand.white"
              color="brand.text"
            >
              {props.isDisabled ? (
                <QuestionIcon color="brand.grey" />
              ) : (
                <QuestionIcon color="brand.bf2" />
              )}
            </Tooltip>
          ) : null}
        </Flex>

        {props.percentage ? (
          <NumberInput

            precision={2}
            min={0}
            max={100}
            id="maxNotAcquiredCommission"
            borderColor="brand.inputBorder"
            bg="brand.inputBackground"
            value={Number(value)}
            onChange={handlePercentage}
            onBlur={console.log}
            errorBorderColor="brand.bf2"
          >
            <NumberInputField type="number"/>
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          </NumberInput>
        ) : (
          <InputGroup>
            <Input
              color="#636E95"
              id={props.id}
              type="number"
              borderColor="brand.inputBorder"
              bg="brand.inputBackground"
              placeholder={props.placeholder}
              focusBorderColor="brand.bf3"
              value={value}
              onChange={handleChange}
              borderWidth="1px"
              onBlur={handleChange}
              errorBorderColor="brand.bf2"
              isInvalid={highlight}
            />
            {rightElement}
          </InputGroup>
        )}
      </FormControl>
    );
  } else {
    return null;
  }
};
